import styled from 'styled-components'

interface Props {
  children: JSX.Element
}

const SectionContainer = styled.div`
  background-color: #fff;
  margin: 10px;
  padding: 20px;

  & h2 {
    font-weight: 600;
    font-style: italic;
    font-size: 1.5rem;
  }
`

export default function FormSectionContainer({ children }: Props): JSX.Element {
  return <SectionContainer>{children}</SectionContainer>
}
